
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Account2ResponseParams} from './Account2ResponseParams';
import {FieldModelAccount2ResponseParams} from './Account2ResponseParams';
import {TradeHistoryRecord} from '../entity/TradeHistoryRecord';
import {FieldModelTradeHistoryRecord} from '../entity/TradeHistoryRecord';

/**
 * SocialTradingMasterCommission2ResponseParams struct
 */
class SocialTradingMasterCommission2ResponseParams {
  /**
   * Initialize struct
   * @param {!Account2ResponseParams=} accountUpdateParams
   * @param {!Array=} marginTradeHistoryRecords
   * @constructor
   */
  constructor (accountUpdateParams = new Account2ResponseParams(), marginTradeHistoryRecords = []) {
    this.AccountUpdateParams = accountUpdateParams
    this.MarginTradeHistoryRecords = marginTradeHistoryRecords
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SocialTradingMasterCommission2ResponseParams}
   * @param {!SocialTradingMasterCommission2ResponseParams} other Other struct
   * @returns {!SocialTradingMasterCommission2ResponseParams} This struct
   */
  copy (other) {
    if (other.AccountUpdateParams != null) {
      this.AccountUpdateParams = Account2ResponseParams.fromObject(other.AccountUpdateParams)
    } else {
      this.AccountUpdateParams = null
    }
    if (other.MarginTradeHistoryRecords != null) {
      this.MarginTradeHistoryRecords = []
      for (let item of other.MarginTradeHistoryRecords) {
        if (item != null) {
          let tempItem
          tempItem = TradeHistoryRecord.fromObject(item)
          this.MarginTradeHistoryRecords.push(tempItem)
        } else {
          this.MarginTradeHistoryRecords.push(null)
        }
      }
    } else {
      this.MarginTradeHistoryRecords = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SocialTradingMasterCommission2ResponseParams}
   * @returns {!SocialTradingMasterCommission2ResponseParams} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SocialTradingMasterCommission2ResponseParamsModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SocialTradingMasterCommission2ResponseParamsModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SocialTradingMasterCommission2ResponseParams}
   * @param {!SocialTradingMasterCommission2ResponseParams} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SocialTradingMasterCommission2ResponseParams)) {
      throw new TypeError('Instance of SocialTradingMasterCommission2ResponseParams is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SocialTradingMasterCommission2ResponseParams}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      AccountUpdateParams: ((this.AccountUpdateParams != null) ? this.AccountUpdateParams : null),
      MarginTradeHistoryRecords: ((this.MarginTradeHistoryRecords != null) ? Array.from(this.MarginTradeHistoryRecords, item => ((item != null) ? item : null)) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SocialTradingMasterCommission2ResponseParams.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SocialTradingMasterCommission2ResponseParams} other Object value
   * @returns {!SocialTradingMasterCommission2ResponseParams} Created struct
   */
  static fromObject (other) {
    return new SocialTradingMasterCommission2ResponseParams().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SocialTradingMasterCommission2ResponseParams}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SocialTradingMasterCommission2ResponseParams.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SocialTradingMasterCommission2ResponseParams}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4162
  }
}

export { SocialTradingMasterCommission2ResponseParams };

/**
 * Fast Binary Encoding SocialTradingMasterCommission2ResponseParams field model
 */
class FieldModelSocialTradingMasterCommission2ResponseParams extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.AccountUpdateParams = new FieldModelAccount2ResponseParams(buffer, 4 + 4)
    this.MarginTradeHistoryRecords = new fbe.FieldModelVector(new FieldModelTradeHistoryRecord(buffer, this.AccountUpdateParams.fbeOffset + this.AccountUpdateParams.fbeSize), buffer, this.AccountUpdateParams.fbeOffset + this.AccountUpdateParams.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.AccountUpdateParams.fbeSize + this.MarginTradeHistoryRecords.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.AccountUpdateParams.fbeExtra + this.MarginTradeHistoryRecords.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSocialTradingMasterCommission2ResponseParams.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4162
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.AccountUpdateParams.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountUpdateParams.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountUpdateParams.fbeSize

    if ((fbeCurrentSize + this.MarginTradeHistoryRecords.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MarginTradeHistoryRecords.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginTradeHistoryRecords.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @param {!SocialTradingMasterCommission2ResponseParams} fbeValue Default value, defaults is new SocialTradingMasterCommission2ResponseParams()
   * @returns {!SocialTradingMasterCommission2ResponseParams} SocialTradingMasterCommission2ResponseParams value
   */
  get (fbeValue = new SocialTradingMasterCommission2ResponseParams()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @param {!SocialTradingMasterCommission2ResponseParams} fbeValue SocialTradingMasterCommission2ResponseParams value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.AccountUpdateParams.fbeSize) <= fbeStructSize) {
      fbeValue.AccountUpdateParams = this.AccountUpdateParams.get()
    } else {
      fbeValue.AccountUpdateParams = new Account2ResponseParams()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountUpdateParams.fbeSize

    if ((fbeCurrentSize + this.MarginTradeHistoryRecords.fbeSize) <= fbeStructSize) {
      this.MarginTradeHistoryRecords.get(fbeValue.MarginTradeHistoryRecords)
    } else {
      fbeValue.MarginTradeHistoryRecords.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginTradeHistoryRecords.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @param {!SocialTradingMasterCommission2ResponseParams} fbeValue SocialTradingMasterCommission2ResponseParams value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSocialTradingMasterCommission2ResponseParams}
   * @param {SocialTradingMasterCommission2ResponseParams} fbeValue SocialTradingMasterCommission2ResponseParams value
   */
  setFields (fbeValue) {
    this.AccountUpdateParams.set(fbeValue.AccountUpdateParams)
    this.MarginTradeHistoryRecords.set(fbeValue.MarginTradeHistoryRecords)
  }
}

export { FieldModelSocialTradingMasterCommission2ResponseParams };

/**
 * Fast Binary Encoding SocialTradingMasterCommission2ResponseParams model
 */
class SocialTradingMasterCommission2ResponseParamsModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSocialTradingMasterCommission2ResponseParams(this.buffer, 4)
  }

  /**
   * Get the SocialTradingMasterCommission2ResponseParams model
   * @this {!SocialTradingMasterCommission2ResponseParamsModel}
   * @returns {!FieldModelSocialTradingMasterCommission2ResponseParams} model SocialTradingMasterCommission2ResponseParams model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SocialTradingMasterCommission2ResponseParamsModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SocialTradingMasterCommission2ResponseParamsModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SocialTradingMasterCommission2ResponseParamsModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SocialTradingMasterCommission2ResponseParamsModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSocialTradingMasterCommission2ResponseParams.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SocialTradingMasterCommission2ResponseParamsModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SocialTradingMasterCommission2ResponseParamsModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SocialTradingMasterCommission2ResponseParamsModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SocialTradingMasterCommission2ResponseParamsModel}
   * @param {!SocialTradingMasterCommission2ResponseParams} value SocialTradingMasterCommission2ResponseParams value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SocialTradingMasterCommission2ResponseParamsModel}
   * @param {!SocialTradingMasterCommission2ResponseParams} value SocialTradingMasterCommission2ResponseParams value, defaults is new SocialTradingMasterCommission2ResponseParams()
   * @return {!object} Deserialized SocialTradingMasterCommission2ResponseParams value and its size
   */
  deserialize (value = new SocialTradingMasterCommission2ResponseParams()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SocialTradingMasterCommission2ResponseParams(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SocialTradingMasterCommission2ResponseParams(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SocialTradingMasterCommission2ResponseParamsModel}
   * @param {!number} prev Previous SocialTradingMasterCommission2ResponseParams model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SocialTradingMasterCommission2ResponseParamsModel };
